module.exports = __webpack_public_path__ + "static/media/a82.9cae18c0.jpg";